module.exports = ApplicationTypes;